import {
  ChangeDetectorRef,
  Directive,
  TemplateRef,
  ViewContainerRef,
  inject,
  input,
} from '@angular/core';

import type { Ability } from '@core/abilities-types';
import { injectUntilDestroyed } from '@core/utils-legacy';

import { AbilityFacade } from '../../facades/ability.facade';

@Directive({
  selector: '[rtAbilityGuard]',
  standalone: true,
})
export class AbilityGuardDirective {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly facade = inject(AbilityFacade);

  public readonly ability = input<Ability | Ability[]>(undefined!, { alias: 'rtAbilityGuard' });
  private untilDestroyed = injectUntilDestroyed();

  public ngOnInit(): void {
    this.checkAbilities();
  }

  private checkAbilities(): void {
    this.facade
      .checkAbilities$(this.ability())
      .pipe(this.untilDestroyed)
      .subscribe(enabled => {
        if (enabled) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
        this.cdRef.detectChanges();
      });
  }
}
